import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosConfig from "../config.js";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext.jsx";
import { MessageCircleQuestion } from "lucide-react";

import "./pages.css";

const Login = () => {
  // states
  const [message, setMessage] = useState("");
  const [showPassword, setVisibility] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  // auth stuff
  const { user, loading, refresh } = useAuth();
  // for getting redirect path
  // get redirect
  const rawRedirect = searchParams.get("redirect");
  // sanitise so we can't redirect to https://rickroll.link
  const redirectTo = rawRedirect && rawRedirect.startsWith("/") ? rawRedirect : "/dashboard";

  // if we're already logged in, uses the authcontext thingamajig
  if (!loading && user) {
    // console.log("Already logged in, redirecting...");
    return navigate(redirectTo, { replace: true });
  }

  const togglePassword = () => {
    setVisibility((prev) => !prev);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axiosConfig.post("/session", formData);

      if (response.status === 201) {
        setMessage("Login Successful!");
        await refresh(); // update logged in user data
        return navigate(redirectTo, { replace: true });
      } 
      
      else {
        setMessage(response.data.message || "Failed to login.");
      }

    } catch (error) {
      console.error("Login failed: ", error);
      setMessage("Failed to login due to server error.");
    }
  };



  return (
    <div className="wrapper">
      <div className="containerBox">
      <div className="pageHeading">
        
        <h2> PATHWAY </h2>
        <p> A waiting list prioritisation application. </p>
        
      </div>

      <div className="loginContainer">
        <h2 className="titleContainer">Login</h2>

        <Form className="loginForm" onSubmit={handleSubmit}>
          <Form.Group className="mb-5" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              className="dataentry"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </Form.Group>

          <Form.Group className="mb-5" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <div className="passwordContainer">
              <Form.Control
                className="dataentry"
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="togglePassword"
                onClick={togglePassword}
                aria-label="Toggle password visibility"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </Form.Group>

          <Button variant="primary" type="submit" className="signInButton">
            Login
          </Button>
        </Form>

        {message && <p className="message">{message}</p>}

        <div className="forgotPswd">
          <Link to="https://passwordreset.microsoftonline.com/"> Forgot password? </Link>
        </div>
      
    </div>


      <button className="SupportButton">
        
        <a href="https://digital.nhs.uk/about-nhs-digital/contact-us "> 
          <MessageCircleQuestion color="white"/>
        </a>
      </button>
    </div>
    </div>
  );
};

export default Login;
